import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import {
    ALLOWED_FILE_CONTENT_TYPES_TO_IMPORT,
    ALLOWED_FILE_EXTENTIONS_TO_IMPORT,
    MAX_FILE_NAME_LENGTH_TO_IMPORT
} from '@silverfort-nodelibs/common/utils/consts';

import importWhiteIcon from '../common/Images/import_file_white.png';

class ImportFromFile extends Component {
    state = {
        loading: false,
        selectedFile: null,
        error: null
    };

    fileChangedHandler = (file) => {
        // Get the extension of the uploaded file
        const file_extension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
        const maxFileSize = this.props.maxFileSize ? this.props.maxFileSize : 1000000;
        const maxFileSizeText = this.props.maxFileSizeText ? this.props.maxFileSizeText : '1 MB';

        // Check if the uploaded file is allowed
        if (
            !ALLOWED_FILE_EXTENTIONS_TO_IMPORT.includes(file_extension) ||
            !ALLOWED_FILE_CONTENT_TYPES_TO_IMPORT.includes(file.type)
        ) {
            this.setState({ error: `Invalid file type`, loading: false });
        } else if (file.name.length > MAX_FILE_NAME_LENGTH_TO_IMPORT) {
            this.setState({
                error: `File name should be up to ${MAX_FILE_NAME_LENGTH_TO_IMPORT} characters`,
                loading: false
            });
        } else if (file.size > maxFileSize) {
            this.setState({ error: `File exceeds maximum size of ${maxFileSizeText}`, loading: false });
        } else {
            this.setState({ selectedFile: file, error: null, loading: false });
        }
    };

    importClickedHandler = () => {
        this.setState({ error: null, loading: true });
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
            const fileContent = e.target.result;
            this.setState({ error: null, loading: false });
            const error = this.props.importClicked(fileContent);
            if (error) {
                this.setState({ error: error });
            }
        };
        fileReader.readAsText(this.state.selectedFile);
    };

    render() {
        return (
            <Modal
                id="importSilverfortConfigurationConfirm"
                dialogClassName="modal-md"
                show
                onHide={this.props.cancelClicked}
                keyboard={false}
                className="z-[5000]"
                backdropClassName="z-[5000]"
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Import {this.props.modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="content">
                        <div className="title">
                            Select {this.props.importDescName} file to import
                            {this.props.importType ? ` (${this.props.importType} format)` : ''}:
                        </div>
                        <div className="fileSelector">
                            <div className="filePath">
                                <span>{this.state.selectedFile ? this.state.selectedFile.name : ''}</span>
                            </div>
                            <div className="importButton">
                                <label htmlFor="configurationImport">
                                    <img src={importWhiteIcon} alt="" />
                                    Choose file
                                </label>
                                <input
                                    type="file"
                                    id="configurationImport"
                                    accept={ALLOWED_FILE_CONTENT_TYPES_TO_IMPORT.toString()}
                                    multiple={false}
                                    disabled={this.state.loading}
                                    onChange={(e) => this.fileChangedHandler(e.target.files[0])}
                                />
                            </div>
                        </div>

                        {this.props.showRestartMsg && (
                            <div className="info">(The Admin Console will be restarted by this operation)</div>
                        )}
                        {this.state.error && (
                            <div className="error">
                                <span>{this.state.error}</span>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button onClick={this.props.cancelClicked}>Cancel</Button>
                        <Button
                            bsStyle={'danger'}
                            disabled={!this.state.selectedFile || this.state.loading}
                            onClick={this.importClickedHandler}>
                            Import
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ImportFromFile;
